<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{ class?: HTMLAttributes['class'] }>()
</script>

<template>
  <div
    :class="
      cn('tracking-tight text-sm font-semibold font-display tabular-nums text-right w-20 pl-4 shrink-0', props.class)
    "
  >
    <slot />
  </div>
</template>
